// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-header {
  width: 100vw;
  background: #fff;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 50;
}
.media-modal .mat-dialog-container .right-menu-mm {
  margin-left: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/new-media/new-media-manager/media-dialog/media-dialog.component.css"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["\r\n.modal-header {\r\n  width: 100vw;\r\n  background: #fff;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  z-index: 50;\r\n}\r\n.media-modal .mat-dialog-container .right-menu-mm {\r\n  margin-left: 0 !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
